export function resolveExtensionNamespace(schemaName: string, outputNamespace?: string): string {
  return outputNamespace ?? (schemaName === 'settings' ? 'core' : schemaName)
}
